import { collection, QueryDocumentSnapshot } from 'firebase/firestore';
import React, { Context, createContext, ReactElement, useContext } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { db } from '../../../core/firebase';


export interface ISubscriberOrdersProviderData {
  invoices: QueryDocumentSnapshot[];
  orders: QueryDocumentSnapshot[];
}

export interface ISubscriberOrdersProvider {
  uid: string;
  dog?: string;
  children(props: ISubscriberOrdersProviderData): (ReactElement | null);
}

export const SubscriberOrdersContext: Context<ISubscriberOrdersProviderData> = createContext<ISubscriberOrdersProviderData>({
  invoices: [],
  orders: []
});

export const useSubscriberOrders = () => useContext(SubscriberOrdersContext);

export default function SubscriberOrdersProvider(props: ISubscriberOrdersProvider) {
  const { uid, dog, children } = {dog: 'default', ...props};

  const [invoices] = useCollection(collection(db, 'scout9-profiles', uid, 'dogs', dog, 'invoices'));
  const [orders] = useCollection(collection(db, 'scout9-profiles', uid, 'dogs', dog, 'orders'));

  return (
    <SubscriberOrdersContext.Provider value={{
      invoices: !!invoices ? invoices.docs : [],
      orders: !!orders ? orders.docs : []
    }}
    >
      {
        children({
          invoices: !!invoices ? invoices.docs : [],
          orders: !!orders ? orders.docs : []
        })
      }
    </SubscriberOrdersContext.Provider>
  );
}
